import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ADNaviModule } from '@internal/common-ui/ad-navi';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToastModule } from 'primeng/toast';
import { TreeModule } from 'primeng/tree';
import { AdExplorerComponent } from './components/ad-explorer/ad-explorer.component';
import { CardViewComponent } from './components/card-view/card-view.component';
import { SampleDetailComponent } from './components/sample-detail/sample-detail.component';
import { DetailCompResolverService } from './services/detail-comp-resolver.service';
import { ExplorerDataService } from './services/explorer-data.service';

@NgModule({
  declarations: [AdExplorerComponent, SampleDetailComponent, CardViewComponent],
  exports: [AdExplorerComponent, CardViewComponent, SampleDetailComponent],
  providers: [DetailCompResolverService, ExplorerDataService],
  imports: [
    CommonModule,
    TreeModule,
    ContextMenuModule,
    PortalModule,
    BreadcrumbModule,
    ButtonModule,
    ToastModule,
    ADNaviModule,
    MatSidenavModule
  ]
})
export class AdExplorerModule {
  // Not required any more
  static forChild(compResolverService): ModuleWithProviders<AdExplorerModule> {
    return {
      ngModule: AdExplorerModule,
      providers: [
        { provide: DetailCompResolverService, useClass: compResolverService }
      ]
    }
  }
}
